import type { LanguageCode } from '@repo/domain';
import { usePaynowClauses } from '@repo/domain-service';
import type { TestId } from '@repo/test-id';

interface Props {
  testId: TestId;
  /** The language for somebody not signed in; a signed-in user always gets their own. */
  language?: LanguageCode;
}

export default function PaynowClauses({ testId, language }: Props) {
  const { paynowClauses } = usePaynowClauses(language ? { language } : undefined);

  if (paynowClauses.length === 0) return null;

  return (
    <div data-testid={testId}>
      {paynowClauses.map((clause) => (
        <div key={clause.title} className="mt-2 flex flex-col gap-2">
          <p className="text-heading text-sm font-medium">{clause.title}</p>
          <div
            className="text-body [&_a]:text-brand text-justify text-sm [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5"
            dangerouslySetInnerHTML={{ __html: clause.content }}
          />
        </div>
      ))}
    </div>
  );
}
